import React from "react";
import { secondaryTextColorOppositeShade } from "../../utils/constants";

export default function QuizTaskIcon({ color = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 267.65 357.79">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Layer_1" data-name="Layer 1">
          <path
            d="M118.34,26.49H78.87A2.67,2.67,0,0,0,76,29.33a2.71,2.71,0,0,0,2.84,2.84h39.47a2.67,2.67,0,0,0,2.84-2.84A2.67,2.67,0,0,0,118.34,26.49Z"
            fill={color}
          />
          <path
            d="M67.08,25.89a2.74,2.74,0,0,0-3.95,0,2.5,2.5,0,0,0-.86,2,2.89,2.89,0,0,0,.86,2,2.35,2.35,0,0,0,2,.86,2.94,2.94,0,0,0,2.83-2.83A2.47,2.47,0,0,0,67.08,25.89Z"
            fill={color}
          />
          <path
            d="M113.61,325.62A2.79,2.79,0,0,0,108.2,327,11,11,0,1,1,95,318.83a15,15,0,0,1,4.82,0,2.85,2.85,0,1,0,1.11-5.59,15.07,15.07,0,0,0-7.31,0,16.89,16.89,0,0,0,4,33.28,7.67,7.67,0,0,0,3.7-.6A16.79,16.79,0,0,0,113.61,325.62Z"
            fill={color}
          />
          <path
            d="M68.05,77A29.38,29.38,0,0,0,38.7,106.39v58.7h9.78V145.54H87.62v19.55H97.4V106.41A29.39,29.39,0,0,0,68.05,77ZM48.48,135.76V106.41a19.57,19.57,0,0,1,39.14,0v29.35Z"
            fill={color}
          />
          <path
            d="M97.4,208.42A24.49,24.49,0,0,0,72.94,184H43.59a4.89,4.89,0,0,0-4.89,4.89h0v78.28A4.89,4.89,0,0,0,43.59,272H72.94a24.46,24.46,0,0,0,14.68-44A24.49,24.49,0,0,0,97.4,208.42Zm-9.78,39.14a14.69,14.69,0,0,1-14.68,14.68H48.48V232.88H72.94a14.68,14.68,0,0,1,14.68,14.68ZM72.94,223.1H48.48V193.74H72.94a14.68,14.68,0,0,1,0,29.36Z"
            fill={color}
          />
          <path
            d="M158.68,5.33H37.76C20.21,5.33,5.59,19.7,5.59,36.9V320c0,17.2,14.71,31.56,32.17,31.56H158.94A31.54,31.54,0,0,0,190.51,320V213a69.23,69.23,0,0,1-7.23-2.13V305.5a2.66,2.66,0,0,1-2.84,2.83H16.94a2.66,2.66,0,0,1-2.84-2.83V51.78a5.33,5.33,0,0,1,.19-1.9A1.71,1.71,0,0,1,15.78,49c3.91-.06,1.11,0,3.91-.06l.86,0H143.72a2.84,2.84,0,1,1,0,5.67H26.15l-6.46.27V302.74H177.52V244.69l0-12.25c0-1.81,0-1.81,0-4a1.36,1.36,0,0,1,0-.2v-19.7c-23.24-10.42-39.25-32.31-39.25-57.63s16-47.21,39.25-57.62V54.7h-8.43a2.84,2.84,0,0,1,0-5.68v-.08h11.35a2.67,2.67,0,0,1,2.84,2.84V91a74.44,74.44,0,0,1,7.23-2.13v-52C190.85,20,176.14,5.33,158.68,5.33Z"
            fill="none"
          />
          <path
            d="M190.51,320a31.54,31.54,0,0,1-31.57,31.56H37.76C20.3,351.51,5.59,337.15,5.59,320V36.9c0-17.2,14.62-31.57,32.17-31.57H158.68c17.46,0,32.17,14.62,31.83,31.57v52q2.79-.66,5.67-1.11V37.5A37.69,37.69,0,0,0,158.68,0H37.76A37.43,37.43,0,0,0,0,37.24V320.55c0,20.55,16.94,37.24,37.76,37.24H158.94a37.2,37.2,0,0,0,37.24-37.24V214.11c-1.92-.31-3.81-.67-5.67-1.12Z"
            fill={color}
          />
          <path
            d="M177.5,228.48c0,2.15,0,2.15,0,4l0,12.25v58.05H19.69V54.88l6.46-.27H143.72a2.84,2.84,0,1,0,0-5.67H20.55l-.86,0c-2.8,0,0,0-3.91.06a1.71,1.71,0,0,0-1.49.91,5.33,5.33,0,0,0-.19,1.9V305.5a2.66,2.66,0,0,0,2.84,2.83h163.5a2.66,2.66,0,0,0,2.84-2.83V210.86c-2-.68-3.89-1.44-5.76-2.28v19.7A1.36,1.36,0,0,0,177.5,228.48Z"
            fill={color}
          />
          <path
            d="M180.44,48.94H169.09V49a2.84,2.84,0,0,0,0,5.68h8.43V93.33c1.87-.84,3.8-1.6,5.76-2.29V51.78A2.67,2.67,0,0,0,180.44,48.94Z"
            fill={color}
          />
          <path
            d="M190.46,83.57h11.45a65.75,65.75,0,0,1,0,131.5H190.46a65.91,65.91,0,0,1-16.69-2.14l-16.91,16.9a4.52,4.52,0,0,1-7.72-3.2V200.46a66.37,66.37,0,0,1-17.28-21.31,65,65,0,0,1-7.15-29.83A65.83,65.83,0,0,1,190.46,83.57ZM156.38,194.64a4.5,4.5,0,0,1,1.81,3.61v17.46l11.06-11.06a4.54,4.54,0,0,1,3.2-1.32,4.34,4.34,0,0,1,1.33.2A56.87,56.87,0,0,0,190.46,206h11.45a56.7,56.7,0,1,0,0-113.4H190.46a56.7,56.7,0,0,0-34.08,102Z"
            fill={color}
          />
          <path
            d="M214,133.07a19.21,19.21,0,0,0-17.76-17.76,19,19,0,0,0-14.41,5.11,19.21,19.21,0,0,0-6.09,14,4.53,4.53,0,0,0,9.05,0,10.1,10.1,0,1,1,12.33,9.86,8.57,8.57,0,0,0-6.75,8.39v10.87a4.53,4.53,0,0,0,9.05,0V153A19.05,19.05,0,0,0,214,133.07Z"
            fill={color}
          />
          <path d="M198.11,178.23a4.51,4.51,0,1,0,1.33,3.2A4.55,4.55,0,0,0,198.11,178.23Z" fill={color} />
        </g>
      </g>
    </svg>
  );
}
